import { Chip } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { OrganizationStatus } from "types/common-types";
import { OrganizationModel } from "services/KnowfullyAdminClient";

export default function OrganizationStatusChip({
  value,
}: {
  value: OrganizationModel;
}) {
  const color =
    value.organizationStatusId === OrganizationStatus.Active
      ? "success"
      : value.organizationStatusId === OrganizationStatus.Deactivated
      ? "error"
      : "info";

  return (
    <Chip
      label={value.organizationStatusName}
      size="small"
      variant="outlined"
      icon={<FiberManualRecordIcon />}
      color={color}
    />
  );
}
